// Registration communication preferences (Views/Components/AccountCreation/Default.cshtml).
// Each group's own checkbox ticks or clears all of its options, and shows ticked, unticked or
// mixed (indeterminate) to match them.
// "Unsubscribe from all" and the options are mutually exclusive: ticking one clears the other.
// The server applies the same rule (unsubscribe wins), so this only keeps the form honest.
export function initRegistrationPreferences() {
    const groupSyncs: Array<() => void> = [];

    document.querySelectorAll<HTMLElement>('[data-preference-group]').forEach(group => {
        const toggle = group.querySelector<HTMLInputElement>('[data-preference-group-toggle]');
        const options = Array.from(group.querySelectorAll<HTMLInputElement>('[data-preference-option]'));

        if (!toggle || options.length === 0) return;

        const sync = () => {
            const checkedCount = options.filter(option => option.checked).length;
            toggle.checked = checkedCount === options.length;
            toggle.indeterminate = checkedCount > 0 && checkedCount < options.length;
        };

        toggle.addEventListener('change', () => {
            options.forEach(option => option.checked = toggle.checked);
            toggle.indeterminate = false;
        });

        options.forEach(option => option.addEventListener('change', sync));

        sync();
        groupSyncs.push(sync);
    });

    const unsubscribe = document.querySelector<HTMLInputElement>('[data-preference-unsubscribe]');
    if (!unsubscribe) return;

    const options = Array.from(document.querySelectorAll<HTMLInputElement>('[data-preference-option]'));
    const toggles = Array.from(document.querySelectorAll<HTMLInputElement>('[data-preference-group-toggle]'));

    unsubscribe.addEventListener('change', () => {
        if (!unsubscribe.checked) return;
        options.forEach(option => option.checked = false);
        groupSyncs.forEach(sync => sync());
    });

    [...options, ...toggles].forEach(input => input.addEventListener('change', () => {
        if (input.checked) unsubscribe.checked = false;
    }));
}
